import React from 'react';
import AwardsSection from '../components/AwardsSection';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Awards-Banner.jpg";
import SeoContentSection from "../components/SeoContentSection";

const Awards = () => {
  return (
    <>
    <UniqueBanner
  image={BannerImg}
  title="NIECCE Teacher Training Course"
  subtitle="Recognizing excellence in early childhood education and teacher training"
 />
 <AwardsSection />
 <SeoContentSection title="NIECCE Teacher Training Course Awards and Recognition">
   <p>
     NIECCE has earned recognition for its contribution to teacher education, Montessori training, and early childhood learning. These awards celebrate the dedication of our faculty, learners, authorised centers, and alumni who continue to raise standards in teaching.
   </p>
   <p>
     Our award-winning approach combines academic knowledge, classroom practice, value-added programs, and career support. Students who choose NIECCE join a teaching community committed to professional growth and better learning experiences for children.
   </p>
 </SeoContentSection>
    </>
  );
};

export default Awards;
